import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { api_freedom } from '../services/apis';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import PrintButton from "../components/PrintButton";

const SimulacaoTransferencia = () => {
	const { identificador } = useParams();
	const [detalheRepasse, setDetalheRepasse] = useState([]);
	const [mensagem, setMensagem] = useState('Carregando ....');
	const informacoesIniciais = identificador ? tryDecodeToken(identificador) : {};

	function tryDecodeToken(token) {
		try {
			return jwt_decode(token);
		} catch (error) {
			console.error("Token decoding error:", error.message);
			return {};
		}
	}

	const fetchContrato = async (contratoId, pessoaId, imobiliariaId) => {
		try {
			const response = await api_freedom.get(
				`/demonstrativo/contrato/detalhe/${contratoId}/${imobiliariaId}/${pessoaId}`,
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			if (response.data.data.indexOf('TOKEN') === -1 && response.data.data[0]) {
				return response.data.data[0];
			}
			return {};
		} catch (error) {
			console.error("Error fetching contract:", error.message);
			return {};
		}
	};

	const fetchCobrancas = async (contratoId, pessoaId, financeiroId, imobiliariaId) => {
		try {
			const response = await api_freedom.get(
				`/demonstrativo/financeiro/idcontrato/${contratoId}/${imobiliariaId || 53}`,
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			if (response.data.data.indexOf('TOKEN') === -1) {
				const parcela = response.data.data.find(
					p => p.id === parseInt(financeiroId)
				);

				if (!parcela) return { descricao_parcela: [], valor_repasse: 0, valor_ted_locador: 0, ted: {} };

				const descricao_parcela_full = response.data.data.filter(
					p => p.mes_ano === parcela.mes_ano && p.cobranca !== 1 && p.servico_id !== 51
				);

				const transf = descricao_parcela_full.find(
					e => e.servico_id === 2 && e.pessoa_id === pessoaId && e.cobranca !== 1
				);

				if (!transf) return { descricao_parcela: [], valor_repasse: 0, valor_ted_locador: 0, ted: {} };

				let valor_ted_locador = 0;
				if (transf.ted_id) {
					const ted_locador = descricao_parcela_full.find(e => e.id === transf.ted_id && e.servico_id !== 51);
					if (ted_locador) {
						valor_ted_locador = ted_locador.valor;
					}
				}

				const valor_repasse = transf.valor;
				const locadorAtual = pessoaId;
				let encontrouServico19 = false;

				const descricao_filtrada = descricao_parcela_full.filter(item => {
					const locadorMatch = item.locador_id == null || item.locador_id === locadorAtual;

					if (item.servico_id === 19) {
						if (!encontrouServico19) {
							encontrouServico19 = true;
							return locadorMatch;
						}
						return false;
					}
					return locadorMatch;
				});

				return {
					descricao_parcela: descricao_filtrada,
					valor_repasse,
					valor_ted_locador,
					ted: transf
				};
			}
			return { descricao_parcela: [], valor_repasse: 0, valor_ted_locador: 0, ted: {} };
		} catch (error) {
			console.error("Error fetching billing data:", error.message);
			return { descricao_parcela: [], valor_repasse: 0, valor_ted_locador: 0, ted: {} };
		}
	};

	const fetchPessoa = async (cpfCnpj, imobiliariaId) => {
		try {
			if (!cpfCnpj || !imobiliariaId) return {};

			const response = await api_freedom.post(
				'/pessoa/cpfcnpj',
				{
					cpf_cnpj: cpfCnpj,
					imobiliaria_id: imobiliariaId
				},
				{ headers: { "authorization": localStorage.getItem('autenticado_freedom') } }
			);

			if (response.data.data.indexOf('TOKEN') === -1 && response.data.data.length > 0) {
				return response.data.data[0];
			}
			return {};
		} catch (error) {
			console.error("Error fetching person data:", error.message);
			return {};
		}
	};
	useEffect(() => {
		const processRepasses = async () => {
			if (!informacoesIniciais || (!informacoesIniciais.repasses && !informacoesIniciais.contrato_id)) {
				setMensagem('Nenhum registro encontrado.');
				return;
			}

			let repassesToProcess = [];
			if (Array.isArray(informacoesIniciais.repasses) && informacoesIniciais.repasses.length > 0) {
				repassesToProcess = informacoesIniciais.repasses;
			} else if (informacoesIniciais.contrato_id) {
				repassesToProcess = [informacoesIniciais];
			}

			if (repassesToProcess.length === 0) {
				setMensagem('Nenhum registro encontrado.');
				return;
			}

			const allDetailedRepasses = await Promise.all(
				repassesToProcess.map(async (repasse) => {
					const { contrato_id, pessoa_id, id, imobiliaria_id } = repasse;

					if (!contrato_id || !id || !imobiliaria_id || !pessoa_id) {
						return null;
					}

					try {
						const [contratoData, cobrancasData] = await Promise.all([
							fetchContrato(contrato_id, pessoa_id, imobiliaria_id),
							fetchCobrancas(contrato_id, pessoa_id, id, imobiliaria_id)]);

						const pessoaData = await fetchPessoa(cobrancasData.ted?.cpf_cnpj, cobrancasData.ted?.imobiliaria_id);

						return {
							contrato: contratoData,
							descricao_parcela: cobrancasData.descricao_parcela,
							pessoa: pessoaData,
							valor_repasse: cobrancasData.valor_repasse,
							valor_ted_locador: cobrancasData.valor_ted_locador,
							ted: cobrancasData.ted,
							originalRepasse: repasse
						};
					} catch (error) {
						console.error('Erro ao processar boleto:', error);
						return null;
					}
				})
			);

			const filteredRepasses = allDetailedRepasses.filter(Boolean);
			setDetalheRepasse(filteredRepasses);
			setMensagem(filteredRepasses.length > 0 ? '' : 'Nenhum registro encontrado.');
		};

		processRepasses();
	}, [identificador]);

	const renderDescricaoParcela = (record, index, currentContrato, currentPessoaId) => {
		if (record.nome.toLowerCase() === "tarifa de ted") {
			return null;
		}

		if (record.servico_id === 6) {
			if (record.pessoa_id !== currentPessoaId) {
				return null;
			}
			return (
				<tr key={index} className="stripedColor">
					<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
						{record.referencia || record.nome}
					</td>
					<td align="right" style={{ fontSize: '14px' }}>
						{parseInt(record.descontar_repasse) === 1 ? '-' : ''}
						{parseFloat(record.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
					</td>
				</tr>
			);
		}

		let valor_repasse_item = parseFloat(record.valor);
		if (record.locador_id == null && record.servico_id !== 19) {
			const percentagem = currentContrato.pessoas?.find(
				p => p.tipo === 'Locador' && currentPessoaId === p.id
			)?.percentagem;

			if (percentagem) {
				valor_repasse_item = valor_repasse_item * (parseFloat(percentagem) / 100);
			}
		}

		return (
			<tr key={index} className="stripedColor">
				<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
					{record.referencia || record.nome}
				</td>
				<td align="right" style={{ fontSize: '14px' }}>
					{parseInt(record.descontar_repasse) === 1 ? '-' : ''}
					{valor_repasse_item.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
				</td>
			</tr>
		);
	};

	const { totalGeralRepasses, servicosAgregados, repassesIndividuais, totalGastoServicos } = useMemo(() => {
		let totalRepasses = 0;
		let totalServicesCalculated = 0;
		const aggregatedServices = {};
		const individualRepasses = [];

		detalheRepasse.forEach(repasse => {
			const currentRepasseValue = parseFloat(repasse.valor_repasse || 0);
			totalRepasses += currentRepasseValue;
			individualRepasses.push({
				name: repasse.ted.pessoa_nome,
				value: currentRepasseValue
			});

			repasse.descricao_parcela.forEach(item => {

				if (item.somar_repasse === 1 || item.descontar_repasse === 1) {
					const serviceName = item.referencia || item.nome;
					let serviceValue = parseFloat(item.valor || 0);

					if (item.locador_id == null && item.servico_id !== 19) {
						const currentContrato = repasse.contrato;
						const currentPessoaId = repasse.originalRepasse.pessoa_id;
						const percentagem = currentContrato.pessoas?.find(
							p => p.tipo === 'Locador' && currentPessoaId === p.id
						)?.percentagem;

						if (percentagem) {
							serviceValue = serviceValue * (parseFloat(percentagem) / 100);
						}
					}

					if (parseInt(item.descontar_repasse) === 1) {
						serviceValue *= -1;
					}

					if (serviceName.toLowerCase() !== "tarifa de ted") {
						aggregatedServices[serviceName] = (aggregatedServices[serviceName] || 0) + serviceValue;
						totalServicesCalculated += serviceValue;
					}
				}
			});
		});

		const servicosArray = Object.entries(aggregatedServices)
			.map(([name, value]) => ({ name, value }))
			.sort((a, b) => a.name.localeCompare(b.name));

		return {
			totalGeralRepasses: totalRepasses,
			servicosAgregados: servicosArray,
			repassesIndividuais: individualRepasses,
			totalGastoServicos: totalServicesCalculated
		};
	}, [detalheRepasse]);


	return (
		<div className='demonstrativo' style={{
			width: '100vw',
			minHeight: '100vh',
			position: 'absolute',
			top: 0,
			left: 0,
			zIndex: 1000,
			backgroundColor: '#f9f9f9',
			overflowY: 'auto',
		}}>
			<div className="container" style={{ color: '#000000', margin: '0 auto', maxWidth: '90%', padding: '20px' }}>
				<div style={{
					width: '100%',
					height: '100%',
					margin: '0',
					boxSizing: 'border-box',
					fontFamily: 'sans-serif',
					fontSize: '18px'
				}}>
					{mensagem ? (
						<div style={{ padding: '20px', textAlign: 'center' }}>{mensagem}</div>
					) : (
						<>
							{detalheRepasse.map((repasse, index) => (
								<div key={index} style={{
									width: '100%',
									padding: '0px 15px',
									paddingTop: '30px',
									pageBreakInside: 'avoid',
									breakInside: 'avoid',
									printColorAdjust: 'exact',
									marginLeft: 'auto',
									marginRight: 'auto',
									backgroundColor: '#fff',
									borderBottom: '1px solid #eee',
									marginBottom: '20px'
								}}>
									<p style={{ fontSize: '12px' }}>
										<span style={{ fontWeight: 'bold' }}>Contrato</span> {repasse.originalRepasse.contrato_id}
									</p>
									<h4 style={{ margin: '0' }}>
										Repasse de &nbsp;
										{repasse.ted.pessoa_nome}
									</h4>

									<div className='table-responsive'>
										<table className='table' style={{ width: '100%' }}>
											<tbody>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }} colSpan="1">Contrato</th>
													<td style={{ fontSize: '14px' }} colSpan="5">
														{repasse.contrato.imovel?.[0] ?
															`${repasse.contrato.imovel[0].endereco}, ${repasse.contrato.imovel[0].numero} ${repasse.contrato.imovel[0].complemento},
                            ${repasse.contrato.imovel[0].bairro} - ${repasse.contrato.imovel[0].cidade} /
                            ${repasse.contrato.imovel[0].estado} - ${repasse.contrato.imovel[0].cep}` : ''}
													</td>
												</tr>
												<tr style={{ backgroundColor: '#eee' }}>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Início</th>
													<td style={{ fontSize: '14px' }}>
														{repasse.contrato.data_inicio ? moment(repasse.contrato.data_inicio).utc(false).format('DD/MM/YYYY') : ''}
													</td>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Término</th>
													<td style={{ fontSize: '14px' }}>
														{repasse.contrato.data_fim ? moment(repasse.contrato.data_fim).utc(false).format('DD/MM/YYYY') : ''}
													</td>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}></th>
													<td style={{ fontSize: '14px' }}></td>
												</tr>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Locador</th>
													<td style={{ fontSize: '14px' }}>{repasse.pessoa.nome}</td>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}>CPF</th>
													<td style={{ fontSize: '14px' }}>{repasse.pessoa.cpf_cnpj}</td>
													<th align="left" style={{ fontSize: '14px', padding: '5px' }}>Email</th>
													<td style={{ fontSize: '14px' }}>{repasse.pessoa.email?.toLowerCase()}</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div style={{ margin: '40px 0px' }}>
										<table style={{ width: '100%' }}>
											<tbody>
												<tr>
													<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }} colSpan="2">Cobrança</td>
												</tr>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px', width: '100px' }}>Referência</th>
													<td style={{ fontSize: '14px' }}>
														{repasse.descricao_parcela.length > 0 &&
															moment(repasse.descricao_parcela.find(p => p.id === parseInt(repasse.originalRepasse.id))?.data_vencimento)
																.utc(false).format('DD/MM/YYYY')}
													</td>
												</tr>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px', width: '100px' }}>Data da TED</th>
													<td style={{ fontSize: '14px' }}>
														{repasse.ted.payment_date ?
															moment(repasse.ted.payment_date).utc(false).format('DD/MM/YYYY') :
															"---"}
													</td>
												</tr>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px', width: '100px' }}>Valor da TED</th>
													<td style={{ fontSize: '14px' }}>
														{parseFloat(repasse.valor_repasse).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
													</td>
												</tr>
												<tr>
													<th align="left" style={{ fontSize: '14px', padding: '5px', width: '100px' }}>Beneficiário da TED</th>
													<td style={{ fontSize: '14px' }}>
														{repasse.originalRepasse.nome}
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div className='table-responsive' style={{ margin: '40px 0px' }}>
										<table className='table' style={{ width: '100%' }}>
											<tbody>
												<tr>
													<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }}>Descrição do repasse</td>
													<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', textAlign: 'right', borderBottom: '1px solid #333' }}>Valor</td>
												</tr>
												{repasse.descricao_parcela.filter(
													dp => dp.somar_repasse === 1 || dp.descontar_repasse === 1
												).map((record, descIndex) => renderDescricaoParcela(record, descIndex, repasse.contrato, repasse.originalRepasse.pessoa_id))}

												<tr style={{ fontWeight: 'bolder' }}>
													<td align="left" style={{ fontSize: '14px', padding: '5px' }}>Total do repasse</td>
													<td align="right" style={{ fontSize: '14px' }}>
														{parseFloat(repasse.valor_repasse).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							))}

							{detalheRepasse.length > 0 && (
								<div
									style={{
										width: '100%',
										padding: '0px 15px',
										paddingTop: '30px',
										marginLeft: 'auto',
										marginRight: 'auto',
										backgroundColor: '#fff',
										borderTop: '1px solid #eee',
										marginBottom: '20px',
										pageBreakBefore: 'always'
									}}>
									<h3 style={{ margin: '0 0 20px 0', textAlign: 'center' }}>Resumo Geral</h3>

									<div className='table-responsive'>
										<table className='table' style={{ width: '100%' }}>
											<tbody>
												<tr>
													<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }} colSpan="2">Detalhe do Repasse por Recebedor</td>
												</tr>
												{repassesIndividuais.map((item, idx) => (
													<tr key={`individual-repasse-${idx}`} className="stripedColor">
														<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
															{item.name}
														</td>
														<td align="right" style={{ fontSize: '14px' }}>
															{item.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
														</td>
													</tr>
												))}
												<tr style={{ fontWeight: 'bolder', backgroundColor: '#e8e8e8' }}>
													<td align="left" style={{ fontSize: '16px', padding: '10px' }}>TOTAL GERAL REPASSADO</td>
													<td align="right" style={{ fontSize: '16px', padding: '10px' }}>
														{totalGeralRepasses.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div className='table-responsive' style={{ marginTop: '30px' }}>
										<table className='table' style={{ width: '100%' }}>
											<tbody>
												<tr>
													<td style={{ margin: '0px', fontSize: '14px', color: '#999', padding: '5px', borderBottom: '1px solid #333' }} colSpan="2">Gastos por Serviço</td>
												</tr>
												{servicosAgregados.length > 0 ? (
													servicosAgregados.map((service, sIndex) => (
														<tr key={`service-cost-${sIndex}`} className="stripedColor">
															<td align="left" style={{ fontSize: '14px', padding: '5px' }}>
																{service.name}
															</td>
															<td align="right" style={{ fontSize: '14px' }}>
																{service.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
															</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="2" style={{ textAlign: 'center', padding: '10px', fontSize: '14px', color: '#666' }}>
															Nenhum gasto de serviço relevante encontrado.
														</td>
													</tr>
												)}
												<tr style={{ fontWeight: 'bolder', backgroundColor: '#e8e8e8' }}>
													<td align="left" style={{ fontSize: '16px', padding: '10px' }}>Total</td>
													<td align="right" style={{ fontSize: '16px', padding: '10px' }}>
														{totalGastoServicos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							)}
						</>
					)}
				</div>
				<PrintButton />
			</div>
		</div>
	);
};

export default SimulacaoTransferencia;